require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/registrer/account/myVouchersModule.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/registrer/account/myVouchersModule.legacy.js
// module id = 742
// module chunks = 31